import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import diePressService from "../services/die-press.service";
import { setMessage } from "./message";
export const fetchDiePressList = createAsyncThunk(
    'diePress/fetchDiePressList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await diePressService.getDiePressList(page, pagesize, search, ordering);
            return response.data; // Assuming response contains { data: { users, totalpage, etc. }}
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const fetchDiePressDropdown = createAsyncThunk(
    'diePress/fetchDiePressDropdown',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await diePressService.getDiePressList(page, pagesize, search, ordering);
            return response.data; // Assuming response contains { data: { users, totalpage, etc. }}
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);
export const fetchArchivedDiePressList = createAsyncThunk(
    'diePress/fetchArchivedDiePressList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await diePressService.getDieArchivePressList(page, pagesize, search, ordering);
            return response.data; // Assuming response contains { data: { users, totalpage, etc. }}
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);
export const fetchDiePressById = createAsyncThunk(
    'inquiry/fetchDiePressById',
    async (id, { rejectWithValue }) => {
        try {
            const response = await diePressService.getPressById(id);
            return response.data; // Return the profile data
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
export const createDiePress = createAsyncThunk(
    'diePress/createDiePress',
    async ({ values }, thunkAPI) => {
        try {
            const response = await diePressService.createDiePress(values);
            return response.data; // Assuming response contains the created category data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const editDiePress = createAsyncThunk(
    'diePress/editDiePress',
    async ({ id, values }, thunkAPI) => {
        try {
            const response = await diePressService.editDiePress(id, values);
            return response.data; // Ensure this returns the updated category data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const deleteDiePress = createAsyncThunk(
    'diePress/deleteDiePress',
    async (id, thunkAPI) => {
        try {
            await diePressService.deleteDiePress(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const unArchiveDiePress = createAsyncThunk(
    'dieGroup/unArchiveDiePress',
    async (id, thunkAPI) => {
        try {
            await diePressService.unArchiveDiePress(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const resetDiePressListThunk = () => (dispatch) => {
    return new Promise((resolve) => {
        dispatch(resetDiePressList()); // Dispatch the synchronous action
        resolve(); // Resolve the promise
    });
};


const initialState = {
    data: [],
    list: [],
    loading: false,
    totalpage: 0,
    currentpage: 1,
    totalRecord: 0,
    status: 'idle',
    error: null,
    hasMore: true,
};

const diePressSlice = createSlice({
    name: 'diePress',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        resetDiePressList: (state) => {
            state.list = []; // This will clear the list
        },
        resetPressDropdown: (state) => {
            state.list = []; // This will clear the list
        },
        resetCurrentDiePressPage: (state) => {
            state.currentpage = 1; // This will clear the currentpage
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDiePressList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDiePressList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentpage;
                state.data = action.payload.results.data || [];  // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.totaldie = action?.payload?.results?.total_die_count || 0;
                state.totaltool = action?.payload?.results?.total_die_tool_count || 0;
                state.currentpage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchDiePressList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });

        builder
            .addCase(fetchDiePressDropdown.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDiePressDropdown.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentpage;
                state.data = action.payload.results.data || [];  // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.currentpage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchDiePressDropdown.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
        builder
            .addCase(fetchArchivedDiePressList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchArchivedDiePressList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentpage;
                state.data = action.payload.results.data || [];  // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.currentpage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchArchivedDiePressList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
        builder
            .addCase(fetchDiePressById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDiePressById.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(fetchDiePressById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(createDiePress.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createDiePress.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.loading = true;
            })
            .addCase(createDiePress.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(editDiePress.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(editDiePress.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const index = state.data.findIndex(category => category.id === action.payload.id);
                if (index !== -1) {
                    state.loading = true;
                    state.data[index] = action.payload;  // Replace the old category with the updated one
                }
            }).addCase(editDiePress.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(deleteDiePress.pending, state => {
                state.status = 'loading';
            })
            .addCase(deleteDiePress.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
                state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
            })
            .addCase(deleteDiePress.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(unArchiveDiePress.pending, state => {
                state.status = 'loading';
            })
            .addCase(unArchiveDiePress.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
            })
            .addCase(unArchiveDiePress.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { resetDiePressList, resetCurrentDiePressPage } = diePressSlice.actions;
const { reducer } = diePressSlice;
export default reducer;
